export const payAsYouGo = [
  {
    titleKey: 'pricing.plans.payg3Day.title',
    price: '$1.49',
    plusQuota: 300000,
    ultraQuota: 15000,
    url: 'https://ocr.lemonsqueezy.com/buy/dbc8444a-2fd9-42fe-b6e3-4b2ee4d8f8ed',
    validForKey: 'pricing.plans.payg3Day.validFor',
    infoKey: 'pricing.plans.payg3Day.info',
    supportLevel: 'standard',
  },
  {
    titleKey: 'pricing.plans.payg14Day.title',
    price: '$2.99',
    plusQuota: 1400000,
    ultraQuota: 70000,
    url: 'https://ocr.lemonsqueezy.com/buy/034f7ae2-a464-41f6-830c-1b59360653b2',
    validForKey: 'pricing.plans.payg14Day.validFor',
    infoKey: 'pricing.plans.payg14Day.info',
    supportLevel: 'standard',
  },
  {
    titleKey: 'pricing.plans.payg30Day.title',
    price: '$4.99',
    plusQuota: 3000000,
    ultraQuota: 150000,
    url: 'https://ocr.lemonsqueezy.com/buy/58ee1706-a827-4dc7-9e96-afc69737cc0d',
    validForKey: 'pricing.plans.payg30Day.validFor',
    infoKey: 'pricing.plans.payg30Day.info',
    supportLevel: 'priority',
    save: '16%',
    best: true,
  },
];

export const subscriptions = [
  {
    titleKey: 'pricing.plans.monthly.title',
    price: '$3.99',
    subtitleKey: 'pricing.plans.monthly.subtitle',
    infoKey: 'pricing.plans.monthly.info',
    plusQuota: 3000000,
    ultraQuota: 200000,
    url: 'https://ocr.lemonsqueezy.com/buy/aef969c3-0e78-4ea7-bf4b-b798d43810df',
  },
  {
    titleKey: 'pricing.plans.quarterly.title',
    price: '$9.99',
    subtitleKey: 'pricing.plans.quarterly.subtitle',
    infoKey: 'pricing.plans.quarterly.info',
    plusQuota: 10000000,
    ultraQuota: 600000,
    url: 'https://ocr.lemonsqueezy.com/buy/8f8156b7-582e-4df6-ad84-dc6dafd514d9',
    save: '16%',
    best: true,
  },
];
